// Canonical ContentType lives in ./revisions — re-export to keep one source.
export { ContentType } from './revisions';

export enum RevisionAction {
  DELETE = 'Delete',
  RESTORE = 'Restore',
}
